<template>
  <row :gutter="16">
    <i-col span="8">
      <div class="ms-text">
        Общий срок выполнения
      </div>
      <alert>{{ getDaysCount(stats.project_time) }}</alert>
    </i-col>
    <i-col span="8">
      <div class="ms-text">
        Отклонение по срокам
      </div>
      <alert type="error">{{ getDaysCount(stats.expiration_time) }}</alert>
    </i-col>
  </row>
</template>

<script>
import { getFormattedCosts } from '@/utils'

export default {
  props: ['stats'],
  methods: {
    getDaysCount (days) {
      return `${days} кал. дн.`
    },
    getFormattedCosts
  }
}
</script>

<style>
</style>
